import { render } from "./otherincome.vue?vue&type=template&id=1bf82466"
import script from "./otherincome.vue?vue&type=script&lang=js"
export * from "./otherincome.vue?vue&type=script&lang=js"

import "./otherincome.vue?vue&type=style&index=0&id=1bf82466&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__